import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Icon } from '@unite-us/app-components';
import ColumnHeader from './ColumnHeader';

const SortableColumnHeader = ({
  children,
  className,
  colName,
  sortBy,
  sortDirection,
  setSort,
  label,
}) => {
  const isSorted = sortBy === colName;
  const activeDirection = sortDirection === 'asc' ? 'down' : 'up';

  const onColClick = () => {
    const newDirection = sortDirection === 'asc' ? 'desc' : 'asc';
    setSort({
      sortBy: colName,
      sortDirection: newDirection,
    });
  };

  return (
    <ColumnHeader
      className={className}
      aria-sort={sortDirection === 'asc' ? 'ascending' : 'descending'}
    >
      <button
        type="button"
        onClick={onColClick}
        className="p-2 -m-2 flex uppercase items-center"
        aria-label={`Sort by ${label} in ${sortDirection === 'asc' ? 'ascending' : 'descending'} order`}
      >
        <div className="flex-none">
          {children}
        </div>
        <div
          className={cx(
            'flex-none ml-2',
            {
              'opacity-50': !isSorted,
            },
          )}
        >
          <div className="flex flex-col items-center leading-none">
            {isSorted ? (
              <Icon
                icon="ChevronArrow"
                direction={activeDirection}
                size={10}
                color="text-blue"
              />
            ) : (
              <>
                <Icon
                  icon="ChevronArrow"
                  direction="up"
                  size={10}
                />
                <Icon
                  icon="ChevronArrow"
                  direction="down"
                  size={10}
                  className="-mt-3px"
                />
              </>
            )}
          </div>
        </div>
      </button>
    </ColumnHeader>
  );
};

SortableColumnHeader.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  colName: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  sortBy: PropTypes.string.isRequired,
  sortDirection: PropTypes.string.isRequired,
  setSort: PropTypes.func.isRequired,
};

SortableColumnHeader.defaultProps = {
  className: '',
};

export default SortableColumnHeader;
